<div class="insomnia-intro" [ngStyle]="{'background-image': 'url(../../../../../assets/img/insomnia/intro-bg.jpg)'}">
  <div class="flex_block">
    <div class="big_icon">
      <img src="assets/img/insomnia/insomnia-icon.svg" alt="">
    </div>

    <div class="flex_block column">
      <div class="text">

        <h1>Experience the thrill of esports at Insomnia Egypt</h1>
        <p>Think your gamer senses are better than the rest? Prove your skill with our esports tournaments.
          chances to win 500,000 EGP in cash prizes and merchandise!
          From mini competitions to big league tournaments, we have different games for everyone to compete in.</p>

        <div class="insomnia_sponsors zero_margin-left desktop hidden-xs hidden-sm">
          <img class="zero_margin-left" width="200" src="assets/img/insomnia/insomnia-logo.svg" alt="">
          <img width="170" src="assets/img/insomnia/nvidia-logo.png" alt="">
          <img width="170px" src="assets/img/insomnia/msi-logo-w.png" alt="">
          <!--<img width="100" src="assets/img/insomnia/ubisoft-logo.png" alt="">-->
          <img width="150" src="assets/img/insomnia/gbarena_logo.png" alt="">
        </div>

      </div>

    </div>

  </div>

  <div class="row" style="margin-top:-20px;">

    <marquee scrollamount="10" class="insomnia_sponsors hidden-md hidden-lg">
      <img class="zero_margin-left" width="200" src="assets/img/insomnia/insomnia-logo.svg" alt="">
      <img width="170" src="assets/img/insomnia/nvidia-logo.png" alt="">
      <img width="170px" src="assets/img/insomnia/msi-logo-w.png" alt="">
      <!--<img width="100" src="assets/img/insomnia/ubisoft-logo.png" alt="">-->
      <img width="150" src="assets/img/insomnia/gbarena_logo.png" alt="">
    </marquee>
  </div>
</div>

<div class="container">
  <div class="row" style="margin-top:50px;">
    <div class="mid_title insomnia">
      <h1>
        Tournaments
      </h1>
    </div>
    <p style="text-align: center; ">
      Entering the tournaments is free of charge but will require you register through this platform.
    </p>
  </div>
  <div class="games_section">

    <div class="flex_block">
      <a routerLink="../fortnite" class="item">
        <img src="assets/img/insomnia/games/fortnite/profile3.jpg" alt="">
      </a>
      <a routerLink="../counter-strike" class="item">
        <img src="assets/img/insomnia/games/counter-strike/profile.jpg" alt="">
      </a>
      <a routerLink="../tekken" class="item">
        <img src="assets/img/insomnia/games/tekken/profile.jpg" alt="">
      </a>
    </div>

    <div class="flex_block">
      <a routerLink="../dota" class="item">
        <img src="assets/img/insomnia/games/dota/profile.jpg" alt="">
      </a>
      <a routerLink="../overwatch" class="item">
        <img src="assets/img/insomnia/games/overwatch/profile.jpg" alt="">
      </a>
      <a routerLink="../league-of-legends" class="item">
        <img src="assets/img/insomnia/games/league-of-legends/profile.jpg" alt="">
      </a>
      <a routerLink="../rainbow-six" class="item">
        <img src="assets/img/insomnia/games/rainbow-six/profile.jpg" alt="">
      </a>
      <a routerLink="../fifa-19" class="item">
        <img src="assets/img/insomnia/games/fifa-19/profile.jpg" alt="">
      </a>
    </div>
  </div>
</div>
